import type React from "react";
import { TextField as MaterialTextField, ThemeProvider } from "@mui/material";

import { muiTheme } from "@/theme";

export type TextFieldProps = Omit<
  React.ComponentProps<typeof MaterialTextField>,
  "variant" | "slotProps"
> & {
  id: string;
  endAdornment?: React.ReactNode;
  readOnly?: boolean;
};

export const TextField = ({
  children,
  endAdornment,
  readOnly,
  ...props
}: TextFieldProps) => {
  return (
    <ThemeProvider theme={muiTheme}>
      <MaterialTextField
        variant="outlined"
        slotProps={{
          input: {
            endAdornment,
            readOnly: readOnly,
          },
        }}
        {...props}
      >
        {children}
      </MaterialTextField>
    </ThemeProvider>
  );
};

TextField.displayName = "TextField";
